import React, { Component } from "react";
// import Login from "./login/Login";
import Login from "./login/LoginCL";
import Apm from "./view/apm/Apm";
import ScreenControl from "./view/screen-control/ScreenControl";
import Portal from "./view/portal/Portal";
// import Emergency from "./view/portal/pages/emergency-page/Emergency";
// import JasaBoga from "./view/portal/pages/services-page/pages/jasaboga-page/JasaBoga";
// import RumahMakan from "./view/portal/pages/services-page/pages/rumahmakan-page/RumahMakan";
// import Hotel from "./view/portal/pages/services-page/pages/hotel-page/Hotel";
// import Form3 from "./view/portal/pages/services-page/pages/hotel-page/pages/Form3";
import Service from "./view/portal/pages/services-page/Service";
// import Info from "./view/portal/pages/info-page/Info";
// import Data from "./view/portal/pages/data-page/Data";
// import Kesga from "./view/portal/pages/info-page/pages/Kesga";
// import Admin from "./view/dinas/admin";
// import PenilaianRumahMakan from "./view/dinas/admin/penilaian/PenilaianRumahMakan";
// import PenilaianJasaBoga from "./view/dinas/admin/penilaian/PenilaianJasaBoga";
// import PenilaianHotel from "./view/dinas/admin/penilaian/PenilaianHotel";
// import VerifikasiRumahMakan from "./view/dinas/admin/verifikasi/VerifikasiRumahMakan";
import Profile from "./view/dinas/admin/profile";
// import ProtectedRoute from "./ProtectedRoute";
import { Route, Switch, Redirect } from "react-router-dom";
// import { routes } from "./routes";
// import Dashboard from "./template/Dashboard";
import Menu from "./routes-new";
// import PIRT from "view/portal/pages/services-page/pages/pirt-page/PIRT";
// import Screening from "./view/screening/screening";
// import ScreeningCertification from "./view/screening/certificate";
import ClinicScreen from "./view/screen-control/ClinicScreen";
import FormTB from "./view/tb/FormTB";
import FormConsent from "view/pendaftaran/pages/registration-page/FormConsent";
// import Vaksin from "./view/vaksin";
// import Farmakmin from "view/portal/pages/info-page/pages/Farmakmin";
// import Home from "template/Home";

/**
 *
 * Component Root
 * Untuk mendefinisikan Sub URL
 * @export
 * @class App
 * @extends {Component}
 */
export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routes: JSON.parse(localStorage.getItem("menu")),
      token: localStorage.getItem("accessToken"),
    };
  }

  render() {
    const menu = this.state.routes !== null ? <Menu /> : "";
    const token = this.state.token ? this.state.token : null;

    return (
      <Switch>
        {token ? (
          <Route path="/" exact>
            <Redirect to="/home" />
          </Route>
        ) : (
          <Route path="/" exact component={Login} />
        )}
        {/* <Route path="/screening" component={Screening} /> */}
        {/* <Route
          exact
          path="/certificate/:id/screening"
          render={(props) => <ScreeningCertification {...props} />}
        /> */}
        <Route path="/apm" component={Apm} />
        <Route path="/admin/profile" component={Profile} />
        <Route path="/screen-control" component={ScreenControl} />
        <Route
          path="/clinic-screen/:id/:clinic"
          render={(props) => <ClinicScreen {...props} />}
        />
        <Route path="/form-tb" component={FormTB} />
        <Route path="/gc-user" component={FormConsent} />

        {/* <Route
          path="/portal/admin/penilaianrumahmakan"
          component={PenilaianRumahMakan}
        />
        <Route
          path="/portal/admin/PenilaianJasaBoga"
          component={PenilaianJasaBoga}
        />
        <Route path="/portal/admin/PenilaianHotel" component={PenilaianHotel} />
        <Route
          path="/admin/VerifikasiRumahMakan"
          component={VerifikasiRumahMakan}
        /> */}
        {/* <Route path="/portal/admin" component={Admin} /> */}
        <Route path="/portal" component={Portal} />
        {/* <Route path="/emergency" component={Emergency} /> */}
        {/* <Route path="/hotel/penilaian" component={Form3} /> */}
        <Route path="/service" component={Service} />
        {/* <Route path="/info" component={Info} /> */}
        {/* <Route path="/data" component={Data} /> */}
        {/* <Route path="/kesga" component={Kesga} /> */}
        {/* <Route path="/farmakmin" component={Farmakmin} /> */}
        {/* <Route path="/vaksincov19" component={Vaksin} /> */}
        {token ? (
          <Menu />
        ) : (
          <Route render={() => <Redirect to={{ pathname: "/" }} />} />
        )}
      </Switch>
    );
  }
}
